import { render, staticRenderFns } from "./CustomFileAnuncio.vue?vue&type=template&id=f56aab6e&"
import script from "./CustomFileAnuncio.vue?vue&type=script&lang=ts&"
export * from "./CustomFileAnuncio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports